import { consoleNotification } from '@mv-submodules/inplant-core-fe/functions/notifications'

interface MeasureColors {
  [key: number]: string
}

const ON_OFF: MeasureColors = {
  0: '#F55A62', // off
  1: '#92D050', // on
} as const

const OPEN_CLOSE: MeasureColors = {
  0: '#92D050', // open
  1: '#F55A62', // close
} as const

const COMMAND: MeasureColors = {
  0: '#FF99CC', // manuale
  1: '#92D050', // automatico
  2: '#6290C3', // locale
  3: '#FFD789', // sezionato
} as const

const COMMAND_WITHOUT_MAINTENANCE: MeasureColors = {
  0: '#FF99CC', // manuale
  1: '#92D050', // automatico
  2: '#6290C3', // locale
} as const

const PROGRAM: MeasureColors = {
  1: '#FF99CC', // P1
  2: '#92D050', // P2
  3: '#6290C3', // P3
  4: '#FFD789', // P4
} as const

const BUFFER_LOADED: MeasureColors = {
  0: '#EEE',
  1: '#FF99CC', // P1
  2: '#92D050', // P2
  3: '#6290C3', // P3
  4: '#FFD789', // P4
  5: '#BE5A38',
} as const

const DIRECTION: MeasureColors = {
  0: '#F55A62', // in
  1: '#00B0F0', // av
}

const DENSIFIER_BELT_STATE: MeasureColors = {
  0: '#F55A62', // off
  1: '#92D050', // on
  2: '#FF99CC', // allarme
  3: '#FFD789', // sezionato
  4: '#6290C3', // pronto
}

const WORKING_MODE: MeasureColors = {
  0: '#92D050', // inverter
  1: '#FFD789', // direct
} as const

const BUNKER_FULL: MeasureColors = {
  0: '#6290C3', // not full
  1: '#F55A62', // full
} as const

const MAINTENANCE_MODE: MeasureColors = {
  1: '#FFD789', // on
} as const

const EMPTY_VALUE_COLOR = '#EEE'

const getMeasureColors = (measureSlug: string): MeasureColors | undefined => {
  if (!COLORS[measureSlug]) {
    consoleNotification(`Measure color not found for measure slug: ${measureSlug}`, 'getMeasureColors', 'warning')
  }
  return COLORS[measureSlug]
}

const getMeasureColorForValue = (measureSlug: string, value: number | null): string => {
  const measureColors = getMeasureColors(measureSlug)
  if (!measureColors || value === null) {
    return EMPTY_VALUE_COLOR
  }
  return measureColors[value] ?? EMPTY_VALUE_COLOR
}

const COLORS: Record<string, Record<number, string>> = {
  command: COMMAND,
  commandWithoutMaintenance: COMMAND_WITHOUT_MAINTENANCE,
  rotScreenMotor1MaintenanceMode: MAINTENANCE_MODE,
  rotScreenMotor2MaintenanceMode: MAINTENANCE_MODE,
  direction: DIRECTION,
  running: ON_OFF,
  program: PROGRAM,
  sync: ON_OFF,
  valvePosition: OPEN_CLOSE,
  key1Inserted: ON_OFF,
  key2Inserted: ON_OFF,
  key3Inserted: ON_OFF,
  key4Inserted: ON_OFF,
  key5Inserted: ON_OFF,
  key6Inserted: ON_OFF,
  key7Inserted: ON_OFF,
  key8Inserted: ON_OFF,
  key9Inserted: ON_OFF,
  key10Inserted: ON_OFF,
  key11Inserted: ON_OFF,
  key12Inserted: ON_OFF,
  key13Inserted: ON_OFF,
  key14Inserted: ON_OFF,
  bufferLoadedWithF015: BUFFER_LOADED,
  bufferLoadedWithF070: BUFFER_LOADED,
  densifierBeltState: DENSIFIER_BELT_STATE,
  workingMode: WORKING_MODE,
  bunkerFull: BUNKER_FULL,
  emptyingCycleActive: ON_OFF,
} as const

export { EMPTY_VALUE_COLOR, getMeasureColors, getMeasureColorForValue }
